export { default } from "./RichTextHyperlink";
